export const DEFAULT_WEB_SEARCH_ENABLED = true
